export class OfficeInfo {
  constructor(name, officeid, street, city, zipcode, latitude, longitude, distance, phone)
  {
    this.name = name;
    this.officeID = officeid;
    this.address = { street: "", zipcode: "", city: "", geolocation: { latitude: 0, longitude: 0 }}
    this.address.street = street;
    this.address.zipcode = zipcode;
    this.address.city = city;
    this.address.geolocation.lat = latitude;
    this.address.geolocation.lng = longitude;
    this.distance = distance ? distance.toFixed(1) : null;
    this.phone = phone || "";
  }
}